<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{data.sysText.editNoteDialog_title | titlecase}}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="note-container">
      <app-text-area
        [control]="form.controls.message"
        [label]="data.sysText.note"
        [icon]="'edit_note'"
        [hint]="!data.note.canEditNote ? data.sysText.note_hint : null">
      </app-text-area>
    </div>
    @if (showVisibilityOptions) {
      <p class="body2">{{data.sysText.editVisibilityDialog_subTitle}}</p>
      <div class="note-container">
        @for (control of visibilityOptionsFormArray.controls; track control; let i = $index) {
          <div class="checkbox">
            <mat-checkbox
              [formControl]="control"
              [aria-label]="visibilityOptionlabels[i]"
            ></mat-checkbox>
            <p class="body2">{{visibilityOptionlabels[i] | titlecase}}</p>
            <mat-icon class="small-icon">{{visibilityOptionIcons[i]}}</mat-icon>
          </div>
        }
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="close()">
      {{data.sysText.cancel}}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save()">
    {{data.sysText.save}}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>
